const NoteCell = ({ text, className, setHovering, onClick }) => {
  // show full text on hover
  return (
    <>
      <div
        className={`bg-white font-chinese text-custom-gray p-2 overflow-hidden cursor-pointer
       hover:whitespace-pre-line hover:break-all  whitespace-nowrap text-ellipsis h-full ${className}`}
        onMouseOver={() => setHovering(true)}
        onMouseOut={() => setHovering(false)}
        onClick={onClick}
      >
        {text ?? ""}
      </div>
    </>
  );
};

export default NoteCell;
